// Forwarder. Routes call sites through @crewmates/api-client-legacy.
//
// Return-shape parity notes (legacy preserved exactly):
//   - reportList / siteSettings used fetch + a custom handleResponse() that parsed the
//     body, checked body.statusCode (app-level, not HTTP), rejected on non-200, and
//     triggered logout on 401/403. The legacy resolved value was the parsed BODY.
//     The forwarder replicates that: it returns axios's response.data and rejects when
//     body.statusCode !== 200. Existing consumers using `result.data.docs` /
//     `result.data.maintenanceMode` keep working unchanged.
//   - updateMaintenanceMode / updateHostMaintenanceMode used bare axios and returned
//     the full axios response (the consumer reads `.data`). The forwarder returns the
//     axios response unchanged.
//
// Path strings and base-URL routing also preserved verbatim. No route normalization.

import { apiAdminClient, apiUserClient } from '../_lib/apiClient';
import { logout } from '../_helpers/logout';

// Mirrors the legacy handleResponse() body. Pulled out as a helper because two of the
// four forwarded methods need it.
function unwrap(response) {
  const body = response && response.data;
  if (body && (body.statusCode === 401 || body.statusCode === 403)) {
    logout();
    if (typeof window !== 'undefined' && window.location) {
      window.location.reload();
    }
  }
  if (body && body.statusCode !== undefined && body.statusCode !== 200) {
    const message = (body && body.userMessage) || (response && response.statusText) || 'Request failed';
    return Promise.reject(message);
  }
  return body;
}

async function reportList(data) {
  const response = await apiAdminClient.get('/report', {
    search: data.search,
    page: data.page,
    limit: data.limit,
  }, { auth: 'bearer' });
  return unwrap(response);
}

async function siteSettings() {
  const response = await apiUserClient.get('/site-settings', null, { auth: 'bearer' });
  return unwrap(response);
}

async function updateMaintenanceMode(maintenanceMode) {
  try {
    const response = await apiAdminClient.post(
      '/site/update-settings',
      { maintenanceMode },
      { auth: 'bearer' },
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function updateHostMaintenanceMode(maintenanceMode) {
  try {
    const response = await apiAdminClient.post(
      '/site/update-settings',
      { maintenanceModeHost: maintenanceMode },
      { auth: 'bearer' },
    );
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const generalService = {
  reportList,
  siteSettings,
  updateMaintenanceMode,
  updateHostMaintenanceMode,
};
